import { Navigate, NonIndexRouteObject, useRoutes } from 'react-router-dom';
import { authRoute } from '../pages/login/AuthRoute';
import { NavigatePath } from './constants/NavigatePath';
import { baseRoute } from './base/BaseRoute';
// import { baseRoute } from './base/Route';

/**
 * role 인터페이스
 *
 * @TODO 서버 설계되면 변경
 */
interface Role {
  roleId: string;
}

/**
 * 라우트
 */
export interface Route extends NonIndexRouteObject {
  /**
   * 역할 목록
   */
  roles: Role[];
  /**
   * 인증 여부
   */
  isAuth: boolean;
  /**
   * 자식 노드
   */
  children?: Route[];
}

/**
 * 라우트 목록
 */
export const routes: Route[] = [
  ...authRoute,
  ...baseRoute,
  {
    path: '/',
    element: <Navigate replace to={NavigatePath.LOGIN} />,
    roles: [],
    isAuth: false,
  },
  {
    path: 'health',
    element: <div>health ok</div>,
    roles: [],
    isAuth: false,
  },
];

/**
 * 페이지 라우팅
 */
export const LayoutRoute: any = () => {
  const element = useRoutes([...routes]);
  return element;
};
